import CertsDetailsList from './CertsDetailsList';

export default CertsDetailsList;
